import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Button, Fade, Popover } from '@material-ui/core'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons'

import RangeFilterMenu from './RangeFilterMenu'

const getRangeLabel = ({ from, to }) => {
  const hasFrom = from !== undefined
  const hasTo = to !== undefined
  if (hasFrom && hasTo) {
    return (
      <span>
        {from} &ndash; {to} Seniors
      </span>
    )
  } else if (hasFrom) {
    return <span>At least {from} Seniors</span>
  } else if (hasTo) {
    return <span>Up to {to} Seniors</span>
  }
  return (
    <div>
      Senior Class Size &nbsp;
      <FontAwesomeIcon icon={faCaretDown} />
    </div>
  )
}

const ClassSizeFilter = ({ from, to, onApply }) => {
  const [anchorEl, setAnchorEl] = useState(false)
  return (
    <div>
      <Button
        aria-haspopup="true"
        aria-controls="class-size-filter-menu"
        color="primary"
        variant="outlined"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {getRangeLabel({ from, to })}
      </Button>
      <Popover
        id="class-size-filter-menu"
        onClose={() => setAnchorEl(null)}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        keepMounted
        getContentAnchorEl={null}
        TransitionComponent={Fade}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <RangeFilterMenu
          from={from}
          to={to}
          onApply={(...args) => {
            onApply(...args)
            setAnchorEl(null)
          }}
        />
      </Popover>
    </div>
  )
}

ClassSizeFilter.propTypes = {
  from: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onApply: PropTypes.func.isRequired,
}

export default ClassSizeFilter
